import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import { useIsProApp } from '../../../../../hooks/useAppType';
import ConsumerAppProfilesRoot from './ConsumerAppProfilesRoot';
import ProAppProfilesRoot from './ProAppProfilesRoot';

export type ProfilesLandingOwnProps = {};

export type ProfilesLandingProps = ProfilesLandingOwnProps;

export type ProfilesLandingRouteProps = {
    route: RouteProp<ProfilesTabParamList, 'root'>;
};

const ProfilesRootScreen: React.FC<ProfilesLandingProps & ProfilesLandingRouteProps> = (props) => {
    const isProApp = useIsProApp();

    return isProApp ? (
        <ProAppProfilesRoot />
    ) : (
        <ConsumerAppProfilesRoot isRegistration={props.route.params?.isRegistration === 'true'} />
    );
};

export default React.memo(ProfilesRootScreen);
